// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TtEi","toggle":"styles_toggle__11uJP","preview":"styles_preview__q-J50"};